import React from 'react';
import { ThinkingOrb } from 'thinking-orbs';

/**
 * The Studio's animated "thinking" avatar. Now a thin wrapper over `ThinkingOrb`
 * (libraries.dev, MIT) so every call site upgrades at once — the SAME 2-state API
 * (`thinking` | `brewing`) is preserved, so nothing that mounts <ThinkingAvatar> changes.
 *   'thinking' — calm working state (writing a script / routing / waiting on the office) → orb 'working'
 *   'brewing'  — a media render is actually in flight (video/image) → orb 'composing'
 * theme='auto' resolves via the app's `data-theme`/`dark` class (Tailwind convention), live-updating.
 * Reduced-motion is handled inside the orb. Mount the moment processing starts; keep it until delivered.
 */
export function ThinkingAvatar({ state = 'thinking', size = 40 }: { state?: 'thinking' | 'brewing'; size?: number }) {
  // The orb ships three hand-tuned sizes (64 chat-avatar, 32 compact, 20 inline). Snap our arbitrary
  // px to the nearest supported size so it always renders a tuned design, never a blurry scale.
  const orbSize: 64 | 32 | 20 = size >= 48 ? 64 : size >= 26 ? 32 : 20;
  return (
    <ThinkingOrb
      state={state === 'brewing' ? 'composing' : 'working'}
      size={orbSize}
      theme="auto"
      aria-label={state === 'brewing' ? 'Rendering' : 'Thinking'}
    />
  );
}
